import { Collapse } from '@material-ui/core'
import { FC } from 'react'

// import { RATEPLANS_QUERY } from '../../graphql/rateplans'
// import { ROOMTYPES_QUERY } from '../../graphql/roomtypes'
// import { getTranslate } from '../../localization'
import {
  ChannelInventoryData,
  MenuItemInInventory,
  RatePlanForInventory
} from '../../../types/inventory'
// import { RatePlan } from '../../types/rateplan'
// import { RoomType } from '../../types/roomtype'
import InventoryChannelRow from './InventoryChannelRowMobile'
import InventoryRatePlanRow from './InventoryRatePlanRowMobile'
import RowSkeleton from './Row.Skeleton'

interface InventoryTableRatePlanProps {
  occupancy: number | 'def'
  hideZeroes: boolean
  ratePlanData: RatePlanForInventory
  selectedInventoryFieldInRatePlan: MenuItemInInventory
  weekendIndexes: number[]
  channelData: ChannelInventoryData[]
  showChannels: boolean
  defaultOccupancy: number
  loadingForChannelInventory: boolean
}
const InventoryTableRatePlan: FC<InventoryTableRatePlanProps> = ({
  weekendIndexes,
  hideZeroes,
  occupancy,
  ratePlanData,
  selectedInventoryFieldInRatePlan,
  channelData,
  showChannels,
  defaultOccupancy,
  loadingForChannelInventory
}) => {
  return (
    <>
      <InventoryRatePlanRow
        defaultOccupancy={defaultOccupancy}
        occupancy={occupancy}
        ratePlanData={ratePlanData?.dataForEachDate}
        hideZeroes={hideZeroes}
        {...{
          weekendIndexes,
          selectedInventoryFieldInRatePlan
        }}
      />
      {!loadingForChannelInventory ? (
        <Collapse in={showChannels}>
          {channelData
            .filter((channel) =>
              channel.ratePlans.some(
                (rp) =>
                  rp.basicDetails.displayRatePlanCode ===
                  ratePlanData.basicDetails.displayRatePlanCode
              )
            )
            .map((channelItem: ChannelInventoryData) => (
              <InventoryChannelRow
                key={channelItem.channelID}
                defaultOccupancy={defaultOccupancy}
                occupancy={occupancy}
                channelData={
                  channelItem.ratePlans.find(
                    (channeldata) =>
                      channeldata.basicDetails.displayRatePlanCode ===
                      ratePlanData.basicDetails.displayRatePlanCode
                  )?.dataForEachDate || []
                }
                hideZeroes={hideZeroes}
                {...{
                  weekendIndexes,
                  selectedInventoryFieldInRatePlan
                }}
              />
            ))}
        </Collapse>
      ) : (
        showChannels &&
        Array(3)
          .fill('')
          .map((_, index) => <RowSkeleton key={index.toString()} />)
      )}
    </>
  )
}

export default InventoryTableRatePlan
